export const POST_FIELDS = `
  fragment postFields on Post {
    _id
    title
    text
    notes
    photos
    files {
      _id
      name
      url
    }
    club
    teams
    notes
    createdBy {
      _id
      firstName
      lastName
    }
    createdAt
    updatedAt
    totalCount
    seenBy {
      _id
      firstName
      lastName
      photo
      seenByParent
    }
  }
`;

export const GET_POST = `
  ${POST_FIELDS}
  query GetPost($postId: String!) {
    post(postId: $postId) {
      ...postFields
    }
  }
`;

export const GET_POSTS = `
  ${POST_FIELDS}
  query GetPosts($skip: Int = 0, $limit: Int = 20) {
    posts(skip: $skip, limit: $limit) {
      ...postFields
    }
  }
`;

export const CREATE_POST = `
  mutation CreatePost($post: PostInput) {
    createPost(post: $post) {
      _id
    }
  }
`;

export const UPDATE_POST = `
  mutation ($id: String, $title: String, $text: String, $files: [String]) {
    editPost(id: $id, title: $title, text: $text, files: $files) {
      _id
    }
  }
`;

export const DELETE_POST = `
  mutation ($id: String!) {
    deletePost(id: $id)
  }
`;

export const GET_CLUB_POSTS = `
${POST_FIELDS}
  query ($clubId: String, $teamId: String, $skip: Int, $limit: Int, $sortingDir: String, $sortingField: String, $fromDate: String, $toDate: String) {
    posts(clubId: $clubId, teamId: $teamId, skip: $skip, limit: $limit, sortingDir: $sortingDir, sortingField: $sortingField, fromDate: $fromDate, toDate: $toDate) {
      ...postFields
    }
  
  }
 `;

export const GET_CLUB_TEAMS = `
  query ($clubId: String!, $skip: Int, $limit: Int) {
   ClubTeams(clubId: $clubId, skip: $skip, limit: $limit) {
      _id
      name
      ageGroup
      teamCode
      sport
      club
    }
}
`;
